import { createBrowserRouter } from 'react-router-dom';

// project-imports
import PagesRoutes from './PagesRoutes';
import NavigationRoutes from './NavigationRoutes'
import LocationRoutes from './LocationRoutes';
import MenuRoutes from './MenuRoutes';
import UserManagmentRoutes from './UserManagementRoute';
import PageNotFoundRoutes from './PageNotFound';
import WebRoutes from './WebContentRoutes';
import EnquiriesRoutes from './EnquiriesRoutes';
import CouponCodeRoutes from './CouponCodeRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [NavigationRoutes, LocationRoutes, MenuRoutes,UserManagmentRoutes, PageNotFoundRoutes, PagesRoutes, WebRoutes, EnquiriesRoutes, CouponCodeRoutes],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
